import React from "react";
import { TruncatedText } from "../truncated-text/truncated-text";

export function DashboardRenderDefault() {
  return function (info: any) {
    const value = info?.getValue();
    return <TruncatedText text={value} />;
  };
}
